import React, { useEffect, useState } from 'react'
import { Col } from 'react-bootstrap'
import {useCallback} from 'react';
import _debounce from 'lodash/debounce';
import Close from "../../../../../src/images/Close.svg";
import Crosshair from "../../../../../src/images/crosshair.svg";
import { SearchIcon } from '../../../../images/svgIcons/svg';
import useCheckMobileScreen from '../../../../hooks/useCheckMobileScreen';
import { isEditStoreLocationModal } from '../../../../components/utils';
import { trackSearchLocationInputClick } from '../../../../analytics/pulseSearchLocationClick';
interface ISearchLocationProps {
    styleClasses: { readonly [key: string]: string; }
    searchLocationProps: any
    locationRenderProps: any
    noLocationProps: any
}

const SearchLocationV2:React.FC<ISearchLocationProps> = ({styleClasses, searchLocationProps,locationRenderProps, noLocationProps}) => {
    const { handleSearchChange, handleEnter, handleCurrentLocation, removeSearch } = searchLocationProps;

    const [search, setSearch] = useState('');
    const [hasLocationPermission, setHasLocationPermission] = useState(false);
    const isThisMobile = useCheckMobileScreen();

    const debounceFn = useCallback(_debounce(handleDebounceFn, 500), []);

    useEffect(() => {
        locationRenderProps?.zipCode && setSearch(locationRenderProps?.zipCode)
    }, [locationRenderProps?.zipCode]);

    useEffect(() => {
      // Check if geolocation permission is already granted
      try {
          if (navigator.permissions && navigator.permissions.query) {
              navigator.permissions.query({ name: 'geolocation' }).then((result) => {
                  setHasLocationPermission(result.state === 'granted');
                  
                  // Listen for permission changes
                  result.onchange = () => {
                      setHasLocationPermission(result.state === 'granted');
                  };
              }).catch(() => {
                  // Fallback: permissions API not supported, keep the button visible
                  setHasLocationPermission(false);
              });
          }
      } catch {
          // Some browsers/extensions throw synchronously on permissions.query
          setHasLocationPermission(false);
      }
  }, []);

    function handleDebounceFn(searchValue) {
        handleSearchChange(searchValue)
    }

    function handleChange(event) {
        setSearch(event.target.value);
        if (event.key === "Enter") {
            handleSearchChange(event.target.value)
        } else {
            debounceFn(event.target.value);
        }
    };

    function removeClickHandler() {
        setSearch('')
        removeSearch()
    }

    return (
      <>
        <h4 className={`h-17 ${isEditStoreLocationModal() ? "mb-0 f-s16 font-Visby-cf f-w6" : "mb-2 f-s21  f-w5 font-Cls"}`}>
          {isEditStoreLocationModal() ? "STORE LOCATION" : "Location"}
        </h4>
        <Col md="6" lg="12" xxl="12">
          <div className={styleClasses.search_bar_wrap}>
            <div
              className={`${styleClasses.search_inn_content} d-flex align-items-center ${isThisMobile && "py-0"} pe-1 ps-2`}
            >
              <div style={{ flexShrink: 0, width: '26px', height: '26px' }}>
                <SearchIcon width={"26"} height={"26"} />
              </div>
              <input
                type="text"
                className={`${styleClasses.form_control} ${styleClasses.form_control_mobile_designv2} form-control `}
                placeholder="Search City and Zip Code"
                data-testid="location-search-input"
                value={search}
                onClick={() => trackSearchLocationInputClick()}
                onChange={(e) => handleChange(e)}
                onKeyUp={(e) => handleChange(e)}
                required
                style={{ flex: 1 }}
              />
              {!!search && <div style={{ flexShrink: 0, width: '30px', height: '30px' }}>
                <span className={styleClasses.search_bar_icon}>
                  <img
                    src={Close}
                    className="img-fluid"
                    alt="close"
                    style={{
                      width:'30px',
                      filter: 'contrast(24.5) brightness(0.8)',
                      fontWeight: 'bold'
                    }}
                    onClick={removeClickHandler}
                  />
                </span>
              </div>}
            </div>
          </div>
        </Col>
        {!locationRenderProps?.locations?.length && !hasLocationPermission && <> 
          {!isEditStoreLocationModal() && <p className="mt-2 mb-2 f-s14 f-w5 text-center mx-1 lh-normal">
            We need this information so we can offer you the nearest Café Zupas
            location.
          </p>}
        <div className={`d-flex justify-content-center my-3 mb-0 justify-content-md-center`}>
          <button
            type="button"
            className={`btn btn-custom p-0 f-w6 p-16 color-sky-blue-light font-Vcf f-s16 d-flex align-items-center gap-2`}
            onClick={(e) => handleCurrentLocation()}
          >
            <img src={Crosshair} className="img-fluid" alt="crosshair" />
            Use My Current Location
          </button>
        </div>
        </>}
      </>
    );
}

export default SearchLocationV2